import { render, staticRenderFns } from "./fapiao-detail.vue?vue&type=template&id=cdb2055a&scoped=true"
import script from "./fapiao-detail.vue?vue&type=script&lang=js"
export * from "./fapiao-detail.vue?vue&type=script&lang=js"
import style0 from "./fapiao-detail.vue?vue&type=style&index=0&id=cdb2055a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb2055a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdb2055a')) {
      api.createRecord('cdb2055a', component.options)
    } else {
      api.reload('cdb2055a', component.options)
    }
    module.hot.accept("./fapiao-detail.vue?vue&type=template&id=cdb2055a&scoped=true", function () {
      api.rerender('cdb2055a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/client-admin/components/fapiao-detail.vue"
export default component.exports